import type { NAuth, NClients } from '@app/types';

export namespace NClientsApi {
  export interface DeleteClientsBySearchIdRequest {
    ActiveBranchId: number;
    searchId: number;
  }
  export type DeleteClientsBySearchIdResponse = void;

  export interface FindClientsByPhoneRequest {
    branchId: number;
    phone1: string;
    phone2: string;
    ActiveBranchId: NAuth.UserPrint['activeBranchId'];
    Database: NAuth.UserPrint['database'];
    UserId: NAuth.UserPrint['userId'];
  }

  export type FindClientsByPhoneResponse = NClients.ModelClientLite[];
}

export enum PeriodEnum {
  Today = 'Today',
  Yesterday = 'Yesterday',
  LastWeek = 'LastWeek',
  LastMonth = 'LastMonth',
  LastThreeMonth = 'LastThreeMonth',
  LastNDays = 'LastNDays',
  Tomorrow = 'Tomorrow',
  NextWeek = 'NextWeek',
  NextMonth = 'NextMonth',
  NextThreeMonth = 'NextThreeMonth',
  NextNDays = 'NextNDays',
  Period = 'Period',
}

export interface ModelVisitsFilterValue {
  HasRecords: boolean | null;
  Statuses: string[] | null;
  MinCountRecords: number | null;
  MaxCountRecords: number | null;
  DateStart: string | null;
  DateEnd: string | null;
  Period: PeriodEnum | null;
  OffsetDays: number | null;
  EmployeeIds: number[] | null;
  ServiceCategoryIds: number[] | null;
  ServiceIds: number[] | null;
  MinServicesCost: number | null;
  MaxServicesCost: number | null;
  TagIds: number[] | null;
}
export interface ModelClientsFilterValue {
  Gender: Array<string | null> | null;
  TagIds: number[] | null;
  MinServicesCost: number | null;
  MaxServicesCost: number | null;
  IsReceivedSMS: boolean | null;
  DateStart: string | null;
  DateEnd: string | null;
  Birthday: PeriodEnum | null;
  OffsetDays: number | null;
  MinAge: number | null;
  MaxAge: number | null;
  BalanceS: number | null;
  BalanceE: number | null;
  HasOpenTasks: boolean | null;
  HasLoyaltyCard: boolean | null;
}
export interface ModelSalesFilterValue {
  ProductIds: number[];
}
export interface ModelVisitsFilter {
  IsInclude: boolean;
  Values: ModelVisitsFilterValue[];
}

export interface ModelClientsFilter {
  IsInclude: boolean;
  Values: ModelClientsFilterValue[];
}

export interface ModelSalesFilter {
  IsInclude: boolean;
  Values: ModelSalesFilterValue[];
}

export interface ModelClientFilter {
  VisitsFilter: ModelVisitsFilter[];
  ClientsFilter: ModelClientsFilter[];
  SalesFilter: ModelSalesFilter[];
}
export interface ModelClientSearchFilter {
  SearchTerm: string | null;
  ClientsPerPage: number;
  Filters: ModelClientFilter[];
}
